import Api from "./Api";
import store from "../state/store";

export default {
  // site
  getSitesWithAreas(params) {
    return Api().get(
      `/sites_list/${store.getters["authfack/currentEntity"].id}`,
      {
        params: {
          filterBy:
            Object.keys(store.getters["grid/getFilterValues"]).length > 0
              ? store.getters["grid/getFilterValues"]
              : {},
          orderBy:
            params && params.orderBy
              ? params && params.orderBy
              : { sortField: null },
          limit: params && params.limit ? params && params.limit : 10,
          page: params && params.page ? params && params.page : 1,
        },
      }
    );
  },
  getSitesWithAreasAndKiosks() {
    return Api().get(`/sites_and_areas/${store.getters["authfack/currentEntity"].id}`)
  },
  getSites() {
    return Api().get(`/sites/${store.getters["authfack/currentEntity"].id}`);
  },
  getNormalSites() {
    return Api().get(`/sites/normal/${store.getters["authfack/currentEntity"].id}`);
  },
  createSite(params) {
    return Api().post(`/site`, params.params);
  },
  getSingleSite(id) {
    return Api().post(`/site/${id}`);
  },
  updateSite(params) {
    return Api().put(`/site/${params.id}`, params.params);
  },
  deleteSite(id) {
    return Api().delete(`/site/${id}`);
  },
  // area
  getAreasHaskiosk(id) {
    return Api().get(`/areas_by_site/${id}`);
  },
  getAreasFilter(params) {
    return Api().get(`/areas/filter/areas/${params.id}`,
      {
        params: params.filterBy,
      });
  },
  checkAreasMode(params) {
    return Api().get(`/check_areas_mode_by_site/${params.id}`);
  },
  getAllAreasInEntity() {
    return Api().get(`/areas/${store.getters["authfack/currentEntity"].id}`);
  },
  getAreasBysites(id) {
    let url = `/areas_by_site/${id.site_id ?? id}`;
    if (id.is_remote) url += `?is_remote=1`;
    return Api().get(url);
  },
  createArea(params) {
    return Api().post(`/area`, params.params);
  },
  updateArea(params) {
    return Api().put(`/area/${params.id}`, params.params);
  },
  moveArea(params) {
    return Api().put(`/area_move/${params.id}`, params.params);
  },
  downloadAreaExeFile(id) {
    return Api().get(`/generate_exe/${id}`);
  },
  deleteArea(id) {
    return Api().delete(`/area/${id}`
    );
  },
  getSpecficCompliances(params) {
    return Api().get(`/compliance_users`, { params });
  },
  getAreaDocument(params) {
    return Api().get(`/document_users`, { params });
  },
  checkSignInOutMode(params) {
    return Api().get(`/check_areas_mode_by_area/${params.id}/${params.action}`);
  },
  getStatusForArea(params) {
    return Api().get(`/check_should_SignedOut_in_area`, { params });
  },
  validateSignOut(params){
    return Api().post(`/validate-sign-out`, params);
  },
  getAllStatusForArea(params) {
    return Api().get(`/validation_user_visiting`, { params });
  },
  checkUserHasVisitInArea(params) {
    return Api().get(`/check_user_has_visit_in_area/${params.user_id}/${params.area_id}`);
  },
  checkUserHasVisitToday(params) {
    return Api().get('/check_user_has_visit_to_day', { params });
  },
  fetchAreasBySiteWithoutSignOut(params) {
    return Api().get(`/areas_by_site_with_out_signed_mode/${params.site_id}/${params.area_id}`);
  },
  getCountUsersSingnedInApi(params) {
    return Api().get(`/get_count_users_singned_in/${params}`);
  },
  checkIfExpectedIsPermitted({ userId, siteId, userTypeId }) {
    return Api().get(`/check_expected_visit_with_in_permitted`, {
      params: {
        entityId: store.getters["authfack/currentEntity"].id,
        userId,
        siteId,
        userTypeId
      }
    });
  },
  //return sites that have at least one normal area
  getSitesWithAreasInEntity() {
    return Api().get(
      `/site_areas_in_entity/${store.getters["authfack/currentEntity"].id}`
    );
  },
};
